/* eslint-disable no-unneeded-ternary */
import React from 'react'
import { Grid } from '@material-ui/core/'
import { Button } from 'components/UI/'
import c from 'classnames'
import arrowBackChat from '../../../../assetss/img/arrowBackChat.svg'
import './index.scss'

const ChatHeaderUser = ({ user, chatUser, authorUser, deleteUserChat, setOpenUserMobileModal }) => {
  return (
    <Grid className='chatHeader'>
      <Grid className='userBlock' onClick={deleteUserChat}>
        <img src={arrowBackChat} />
        <Grid className='userNameBlock'>
          {authorUser?.name}
        </Grid>
      </Grid>
      {chatUser?.authorUuid === user?.user?.uuid ? (
        <Button onClick={() => setOpenUserMobileModal(true)} className='btnChatHeaderAvtor'>
          {chatUser?.meeting?.status === 'accepted' && chatUser?.status === 'scheduled' ? 'Meeting details' : 'Schedule meeting'}
        </Button>
      ) : (
        <Button
          disabled={
            chatUser?.meeting?.status === 'declined' ? true : chatUser?.meeting?.status === 'accepted' && chatUser?.status === 'meeting' ? (
              true
            ) : chatUser?.status === 'request' ? true : chatUser?.status === 'meeting' && !chatUser?.meeting ? true : false
          }
          className={c(
            'btnChatHeader',
            chatUser?.status === 'meeting' && chatUser?.meeting?.status === 'requested' && 'btnChatHeaderBack',
            chatUser?.status === 'scheduled' && chatUser?.meeting?.status === 'accepted' && 'btnChatHeaderBack',
          )}
          onClick={() => setOpenUserMobileModal(true)}
        >
          {
            chatUser?.status === 'meeting' && chatUser?.meeting?.status === 'requested' ? (
              'Meeting details'
            ) : chatUser?.status === 'scheduled' && chatUser?.meeting?.status === 'accepted' ? (
              'Meeting details'
            ) : chatUser?.status === 'meeting' && chatUser?.meeting?.status === 'accepted' ? (
              'Meeting details'
            ) : chatUser?.status === 'meeting' && chatUser?.meeting?.status === 'declined' ? (
              'Meeting details'
            ) : 'Meeting details'
          }
        </Button>
      )}
    </Grid>
  )
}

export default ChatHeaderUser
